
import {
  setStatus,
  updateBookmarkStatusWithBlogId,
  updateUpvoteStatusWithBlogId,
} from "../../reduxStore/features/learnSlice";
import { handleSnackbarOpen } from "../../reduxStore/features/snackbarSlice";
import { loadPublicArticlesAction } from "../../reduxStore/middleware/learnMiddleware";
import {
  bookmarkBlogAsync,
  upvoteBlogAsync,
} from "../../reduxStore/services/blogsService";
import { AppDispatch } from "../../reduxStore/store";
import { ArticleType, DataStatus } from "../../reduxStore/types/LearnTypes";
import { email } from "../axiosInstance";
import { QUERY_COURSE, QUERY_FILE } from "../constants/urlParamsConstants";



export const loadPublicArticlesByType = async (
  dispatch: AppDispatch,
  page: number,
  resultsPerPage: number,
  articleType: ArticleType,
  searchString: string = "",
  filterString: string = ""
) => {
  try {
    dispatch(
      setStatus({ articleType: articleType, status: DataStatus.loading })
    );
    await dispatch(
      loadPublicArticlesAction({
        page,
        resultsPerPage,
        articleType,
        searchString,
        filterString,
      })
    );
  } catch (error) {
    console.error(
      `Error loading public articles : ${articleType} : ", ${error}`
    );
  }
};

export const handleArticleNavigation = (
  navigate: any,
  isBlog: boolean = false,
  articleId: string,
  fileId: string
) => {
  navigate(
    `/${
      isBlog ? "blog" : "learn"
    }/?${QUERY_COURSE}=${articleId}&${QUERY_FILE}=${fileId}`
  );
};

export const dispatchErrorMessageSnackbar = (
  dispatch: any,
  message: string
) => {
  dispatch(
    handleSnackbarOpen({
      severity: "error",
      message: message,
    })
  );
};

export const handleBlogUpvote = async (
  dispatch: AppDispatch,
  blogId: string,
  isUpvote: boolean
) => {
  try {
    if (!email) {
      console.error("User email is not available");
      dispatch(
        handleSnackbarOpen({
          severity: "warning",
          message: "Please login to perform this action on blogs!",
        })
      );
      return null;
    }
    const response = await upvoteBlogAsync(blogId);
    if (response.status === 200) {
      dispatch(
        updateUpvoteStatusWithBlogId({
          blogId: response.data.blogId,
          likes: response.data.likes || 0,
          dislikes: response.data.dislikes || 0,
          likedBy: response.data.likedBy || [],
          dislikedBy: response.data.dislikedBy || [],
        })
      );
      dispatch(
        handleSnackbarOpen({
          severity: "success",
          message: `Blog ${
            response.data.isUpvoted ? "upvoted" : "downvoted"
          } successfully!`,
        })
      );
    } else {
      dispatchErrorMessageSnackbar(
        dispatch,
        `Failed to ${isUpvote ? "upvote" : "downvote"} the blog!`
      );
    }
    return response;
  } catch (error) {
    console.error(`Error voting blog: ${blogId}, ${error}`);
    dispatchErrorMessageSnackbar(
      dispatch,
      "Failed to perform this voting operation, please try again later!"
    );
    return null;
  }
};

export const handleBlogBookmark = async (
  dispatch: AppDispatch,
  blogId: string,
  isAddBookmark: boolean
) => {
  try {
    if (!email) {
      console.error("User email is not available");
      dispatch(
        handleSnackbarOpen({
          severity: "warning",
          message: "Please login to bookmark blogs!",
        })
      );
      return null;
    }
    const response = await bookmarkBlogAsync(blogId);
    if (response.status === 200) {
      dispatch(
        updateBookmarkStatusWithBlogId({
          blogId: response.data.blogId,
          bookmarkedBy: response.data.bookmarkedBy || [],
        })
      );
      dispatch(
        handleSnackbarOpen({
          severity: "success",
          message: `Blog ${
            response?.data?.isBookMarked ? "bookmarked" : "bookmark removed"
          } successfully!`,
        })
      );
    } else {
      dispatchErrorMessageSnackbar(
        dispatch,
        `Failed to ${isAddBookmark ? "bookmark" : "remove bookmark"} the blog!`
      );
    }
    return response;
  } catch (error) {
    console.error(`Error bookmarking blog: ${blogId}, ${error}`);
    dispatchErrorMessageSnackbar(
      dispatch,
      "Failed to perform this bookmark operation, please try again later!"
    );
    return null;
  }
};
